(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.VisibilityDependence = Lfl.VisibilityDependence || {};

    (function (VisibilityDependence, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.VisibilityDependence, 'VdoiEventDispatcher')) {
            return;
        }

        /*
         |===============================================================================================================
         | Class definition
         |===============================================================================================================
         */

        /**
         * A core visibility-dependence class that detects the controlling input's changes and notifies registered
         * handlers about their changes and current state.
         *
         * @param {object} parameters
         * @param {Lfl.VisibilityDependence.VdoiControllingInputResolver} parameters.controllingInput The resolved
         * controlling input details.
         *
         * Note: We do not use the autoActivate option, as this is an internal class used by auto-activated code.
         *
         * @memberOf Lfl.VisibilityDependence
         * @lends Lfl.VisibilityDependence.VdoiEventDispatcher
         * @constructor
         */
        Lfl.VisibilityDependence.VdoiEventDispatcher = function (parameters) {
            /*
             |-----------------------------------------------------------------------------------------------------------
             | Construction
             |-----------------------------------------------------------------------------------------------------------
             */

            var controllingInput;
            /**
             * Whether the controlled elements should be currently visible.
             * @type {boolean}
             */
            var visible;

            var showingHandlers = [];
            var hidingHandlers = [];

            function init() {
                if (typeof parameters.controllingInput === 'undefined') {
                    throw new Error("The controlling input must be provided.")
                }
                controllingInput = parameters.controllingInput;

                controllingInput.getControllingInput().on('change', function () {
                    handleChange();
                });

                visible = controllingInput.isValueSelected();
            }

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Public methods
             |-----------------------------------------------------------------------------------------------------------
             */

            /*
            |----------------------------------------------------------------------------------------
            | Event handling
            |---------------- */
            /**
             * Register a callback to the showing event.
             *
             * And calls it immediately if the element is currently visible.
             *
             * @param {function} callback
             */
            this.onShowing = function (callback) {
                showingHandlers.push(callback);
                if (true === visible) {
                    callback();
                }
            };

            /**
             * Register a callback to the hiding event.
             *
             * And calls it immediately if the element is currently not visible.
             *
             * @param {function} callback
             */
            this.onHiding = function (callback) {
                hidingHandlers.push(callback);
                if (true !== visible) {
                    callback();
                }
            };

            // Note: onShown and onHidden are not implemented yet.

            /*
            |----------------------------------------------------------------------------------------
            | Getters
            |---------*/
            /**
             * Whether the controlled elements should be currently visible.
             * @returns {boolean}
             */
            this.isVisible = function () {
                return visible;
            };

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Private methods
             |-----------------------------------------------------------------------------------------------------------
             */

            function handleChange() {
                // Note: we do not use jQuery events to call the handlers.
                //       See: Vdoi::EventDispatcher::NativeJqueryEventsVsOurOwn::CantUseJquery
                if (controllingInput.isValueSelected()) {
                    visible = true;
                    _.each(showingHandlers, function(callback){
                        callback();
                    })
                } else {
                    visible = false;
                    _.each(hidingHandlers, function(callback){
                        callback();
                    })
                }
            }

            /*
             |-------------------------------------------------------------------------------------------------------
             | First initialization
             |-------------------------------------------------------------------------------------------------------
             */
            init();
        };
    }(Lfl.VisibilityDependence, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
